import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { T } from '../../../../../../Translations';

interface DrawerWarningAlertProps {
  onViewDetails: () => void;
}

function DrawerWarningAlert({ onViewDetails }: DrawerWarningAlertProps) {
  return (
    <div className="mb-6 p-4 bg-muted/30 border-l-4 border-primary rounded-md">
      <div className="flex items-start gap-3">
        <ExclamationTriangleIcon
          className="w-5 h-5 text-primary mt-0.5 flex-shrink-0"
          aria-hidden="true"
        />
        <div className="flex-1">
          <p style={{ fontWeight: 'var(--font-weight-medium)', marginBottom: '4px' }}>
            <T kind="Some programs will not be visible to learners" />
          </p>
          <p className="text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
            <T kind="Your organization's license does not allow access to all programs in this group." />
          </p>
        </div>
        <button
          onClick={onViewDetails}
          className="px-3 py-1.5 bg-primary text-primary-foreground rounded-md transition-all hover:opacity-90 flex-shrink-0"
          style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
          data-intercom-target="builder-v2-drawer-view-license-details"
        >
          <T kind="View Details" />
        </button>
      </div>
    </div>
  );
}

export default DrawerWarningAlert;
